import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import * as React from "react";
import { cn } from "@components/utils/utils";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

interface CollapsibleTriggerWithHoverProps extends React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleTrigger> {
  isOpen: boolean;
}

/**
 * A CollapsibleTrigger that only shows hover effect when the collapsible is closed.
 * This is the recommended UX pattern:
 * - Closed: hover signals "click to expand"
 * - Open: user focuses on content, no hover distraction
 */
const CollapsibleTriggerWithHover = React.forwardRef<
  React.ElementRef<typeof CollapsiblePrimitive.CollapsibleTrigger>,
  CollapsibleTriggerWithHoverProps
>(({ isOpen, className, ...props }, ref) => (
  <CollapsiblePrimitive.CollapsibleTrigger ref={ref} className={cn(className, !isOpen && "hover:bg-muted/50")} {...props} />
));
CollapsibleTriggerWithHover.displayName = "CollapsibleTriggerWithHover";

export { Collapsible, CollapsibleTrigger, CollapsibleContent, CollapsibleTriggerWithHover };
